// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.h-splitter[data-v-4960e675] {\n    position: absolute;\n    left: 0;\n    height: 5px;\n    margin-top: -2px;\n    width: 100%;\n    z-index: 1;\n    //background-color: rgba(255,255,255, 0.4);\n    //opacity: 0.5;\n    pointer-events: all;\n}\n.h-splitter[data-v-4960e675]:hover {\n    cursor: row-resize;\n    opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
